export default "__VITE_ASSET__jWA36kVT__"